module.exports = {"title":"You're missing some event dates!","ok":"Ok","description":"Your event doesn't seem to have dates set up.<br />Please make sure you have created date(s) for your event by clicking the <strong>Click to create these dates</strong> button before publishing or saving."}


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateEvent/NoDatesModalError/locales/en.json
// module id = 1692
// module chunks = 0